// frontend/src/components/LoginPage.js
import { useState } from "react";
import { signIn, resetPassword } from "@/lib/auth";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("login"); // login | reset | reset-sent

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await resetPassword(email);
      setMode("reset-sent");
    } catch (err) {
      setError(err.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F5EE] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-[#1E1E1E] px-6 py-4 text-center">
          <h1 className="text-xl text-[#F5EDE0]" style={{ fontFamily: "Federo, serif" }}>
            578 Site Admin
          </h1>
        </div>

        {mode === "reset-sent" ? (
          <div className="leadline-border bg-[#F5EDE0] p-6 space-y-4">
            <p className="text-sm text-[#3A3530]">
              If an account exists for <strong>{email}</strong>, a password reset link has been sent. Check your email.
            </p>
            <button
              onClick={() => { setMode("login"); setError(null); }}
              className="w-full bg-[#1E1E1E] text-[#F5EDE0] py-2 text-sm leadline-border-thin"
            >
              Back to Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={mode === "login" ? handleLogin : handleReset} className="leadline-border bg-[#F5EDE0] p-6 space-y-4">
            {error && (
              <div className="bg-[#E05A2D] text-[#F5EDE0] px-3 py-2 text-sm">{error}</div>
            )}
            <label className="block">
              <span className="block text-xs mb-1 text-[#3A3530]">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full leadline-border-thin px-3 py-2 bg-white text-sm"
                placeholder="you@example.com"
              />
            </label>

            {mode === "login" && (
              <label className="block">
                <span className="block text-xs mb-1 text-[#3A3530]">Password</span>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="w-full leadline-border-thin px-3 py-2 bg-white text-sm pr-16"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-[#3A3530] hover:underline"
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </label>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#2B7D6E] text-[#F5EDE0] py-2 text-sm leadline-border-thin disabled:opacity-50"
            >
              {loading
                ? (mode === "login" ? "Signing in..." : "Sending...")
                : (mode === "login" ? "Sign In" : "Send Reset Link")}
            </button>

            <div className="text-center">
              {mode === "login" ? (
                <button
                  type="button"
                  onClick={() => { setMode("reset"); setError(null); }}
                  className="text-xs text-[#3A3530] hover:underline"
                >
                  Forgot password?
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => { setMode("login"); setError(null); }}
                  className="text-xs text-[#3A3530] hover:underline"
                >
                  Back to Sign In
                </button>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
